import apiClient from "./api";

export interface Warehouse {
  id?: number;
  code: string;
  name: string;
  phone?: string;
  address?: string;
  email?: string;
  city?: string;
  country?: string;
  zip_code?: string;
  status?: number;
}

const warehouseService = {
  async getWarehouses(): Promise<Warehouse[]> {
    const response = await apiClient.get("/warehouses");
    return response.data.data ?? response.data;
  },

  async getWarehouse(id: number): Promise<Warehouse> {
    const response = await apiClient.get(`/warehouses/${id}`);
    return response.data;
  },

  async createWarehouse(input: Warehouse): Promise<Warehouse> {
    const response = await apiClient.post("/warehouses", input);
    return response.data;
  },

  async updateWarehouse(id: number, input: Partial<Warehouse>): Promise<Warehouse> {
    const response = await apiClient.put(`/warehouses/${id}`, input);
    return response.data;
  },

  async deleteWarehouse(id: number): Promise<void> {
    await apiClient.delete(`/warehouses/${id}`);
  },
};

export default warehouseService;
